import styled from 'styled-components'

export const FichaWrapper = styled.div`
  position: inherit;
  z-index: 1;
`

export const Separador = styled('div')`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grey24};
  margin: 24px 0px;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin: 0px 0px 16px 0px;
  }
`
